"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SettlementType;
(function (SettlementType) {
    SettlementType["DISCOUNT_EUR"] = "discount_eur";
    SettlementType["DISCOUNT_UNIT_EUR"] = "discount_unit_eur";
    SettlementType["DISCOUNT_STATIC_PCT"] = "discount_static_pct";
    SettlementType["DISCOUNT_TOTAL_PCT"] = "discount_total_pct";
    SettlementType["PHYSICAL"] = "physical";
    SettlementType["CASHBACK"] = "cashback";
    SettlementType["INFORMATION"] = "information";
})(SettlementType || (SettlementType = {}));
exports.default = SettlementType;
